import AutomatedReportGeneration from "../../../../src/pages/use-cases/page-content/content-publishing/automated-report-generation.md";
import * as React from 'react';
export default {
  AutomatedReportGeneration,
  React
};